import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import firebase from 'firebase'
import RefreshToken from "./Mixins/RefreshToken";

Vue.use(Vuex);
Vue.mixin(RefreshToken);

export default new Vuex.Store({
    state: {
        publicVapidCalled: false,
        user: JSON.parse(localStorage.getItem('user')) || {},
        status: localStorage.getItem('status') || '',
        accessToken: localStorage.getItem('token') || '',
        refreshToken: localStorage.getItem('refreshToken') || '',
        newOrderId: null,
        bellOn: false,
        updateBranchNewOrders: false,
        refreshBillingDatatable: false,
        takeAwayAddressId: 1447,
        websocket: null,
        fetchOrderDetails: false,
        toast: "",
        collapseId: 0,
        notificationRing: new Audio('sounds/tring_tring.mp3'),
        mainAppURL: process.env.VUE_APP_BASE_URL
    },
    getters:{
        accessToken: state => state.accessToken,
        mainAppURL: state => state.mainAppURL,
        user_branch: state => state.user.branch,
        user: state => state.user,
        websocket: state => state.websocket,
        fetchOrderDetails: state => state.fetchOrderDetails,
        takeAwayAddressId: state => state.takeAwayAddressId,
        isDVMportal: state => state.mainAppURL.includes("deliverymonsters"),
        getValidPlatform: (state, getters) => (getters.isDVMportal) ? "Bayked" : "Babyhug"
    },
    mutations: {
        public_vapid_called_mutation(state) {
            state.publicVapidCalled = true;
        },
        auth_request(state) {
            state.status = 'loading';
        },
        auth_success(state, payLoad) {
            state.status = 'success';
            state.accessToken = payLoad.accessToken;
            state.refreshToken = payLoad.refreshToken;
            state.user = payLoad.user;
        },
        auth_refresh_token(state, newToken) {
            state.accessToken = newToken;
        },
        auth_error(state) {
            state.status = 'error';
            state.accessToken = '';
            state.refreshToken = '';
            state.user = {};
        },
        auth_logout(state) {
            state.status = '';
            state.accessToken = '';
            state.refreshToken = '';
            state.user = {};
        },
        new_order_id(state, payload) {
            state.newOrderId = payload;
        },
        bell_on(state, payload) {
            state.bellOn = payload;
        },
        update_branch_new_order(state, payload) {
            state.updateBranchNewOrders = payload;
        },
        refresh_datatable(state, payload){
            state.refreshBillingDatatable= payload;
        },
        fetch_order_detail(state, payload){
            state.fetchOrderDetails = payload;
        },
        websocket(state, payload){
            state.websocket = payload;
        },
        toast(state, payload){
            state.toast = payload;
        },
        updateCollapseValue(state, payload) {
            state.collapseId = payload;
        }
    },
    actions: {
        login({commit, state, dispatch}, userCreds) {
            return new Promise((resolve, reject) => {
                commit('auth_request');
                let params = new URLSearchParams();
                params.append('grant_type', 'password');
                params.append('username', userCreds.username);
                params.append('password', userCreds.password);
                axios({
                    url: state.mainAppURL + 'oauth/token',
                    data: params,
                    auth: {username: 'EASY_C2D_ENGINE', password: 'EASY_C2D_SECRET'},
                    headers: {"Content-type": "application/x-www-form-urlencoded; charset=utf-8"},
                    method: 'POST'
                }).then(resp => {
                    const token = resp.data.access_token;
                    const refreshToken = resp.data.refresh_token;
                    localStorage.setItem('token', token);
                    localStorage.setItem('refreshToken', refreshToken);
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                    axios({
                        url: state.mainAppURL + 'users/get_user_detail',
                        headers: {"Content-type": "application/x-www-form-urlencoded; charset=utf-8"},
                        method: 'POST'
                    }).then(resp => {
                        localStorage.setItem('user', JSON.stringify(resp.data));
                        localStorage.setItem('status', "success");
                        let payLoad = {
                            accessToken: token,
                            refreshToken: refreshToken,
                            user: resp.data
                        };
                        commit('auth_success', payLoad);
                        resolve(resp);
                        dispatch('validateUserAndCreateWebsocketConnection');
                    });

                }).catch(err => {
                    commit('auth_error');
                    localStorage.setItem('status', "error");
                    localStorage.setItem('user', JSON.stringify({}));
                    localStorage.setItem('refreshToken', "");
                    localStorage.setItem('token', "");
                    reject(err);
                });
            });
        },
        async logout({state, commit, dispatch}) {
            const resp = await axios({
                url: state.mainAppURL + 'oauth/logout',
                headers: {"Content-type": "application/x-www-form-urlencoded; charset=utf-8"},
                method: 'POST'
            })
            if(resp.data.status === 200) {
                if (state.websocket !== null) {
                    dispatch('closeWebsocketConnection');
                }
                localStorage.setItem('status', "");
                localStorage.setItem('user', JSON.stringify({}));
                localStorage.setItem('refreshToken', "");
                localStorage.setItem('token', "");
                dispatch('stopNotificationBell');
                commit('auth_logout');
            }
        },
        refreshToken({commit, state, dispatch}) {
            return new Promise((resolve, reject) => {
                let params = new URLSearchParams();
                params.append('grant_type', 'refresh_token');
                params.append('refresh_token', state.refreshToken);
                axios({
                    url: state.mainAppURL + 'oauth/token',
                    data: params,
                    auth: {username: 'EASY_C2D_ENGINE', password: 'EASY_C2D_SECRET'},
                    headers: {"Content-type": "application/x-www-form-urlencoded; charset=utf-8"},
                    method: 'POST'
                }).then(resp => {
                    const token = resp.data.access_token;
                    localStorage.setItem('token', token);
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                    commit('auth_refresh_token', token);
                    resolve(token);
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.accessToken;
                    dispatch('validateUserAndCreateWebsocketConnection');
                }).catch(err => {
                    commit('auth_error');
                    localStorage.setItem('status', "error");
                    localStorage.setItem('user', JSON.stringify({}));
                    localStorage.setItem('refreshToken', "");
                    localStorage.setItem('token', "");
                    reject(err);
                });
            });
        },
        async initFCM({state, commit, dispatch}) {
            return new Promise((resolve, reject) => {
                const messaging = firebase.messaging();
                if (!state.publicVapidCalled) {
                    messaging.usePublicVapidKey("BFnR1ECnRtVnImTLtw0duVpbJqrgEvclA2NoUI6d0hWDfI89zBciCz34bwIFnWA4JlKNtMKrf4XH_WNF4dVgZKw");
                    commit("public_vapid_called_mutation");
                }
                messaging.requestPermission().then(function () {
                    console.log('Notification permission granted.');
                    messaging.getToken().then(function (currentToken) {
                        if (currentToken) {
                            console.log("Current Token: " + currentToken);
                            let param = new URLSearchParams();
                            param.append("token", currentToken);
                            param.append("branch_id", state.user.branch.id);
                            axios.post(state.mainAppURL + "restaurants/update_branch_fcm_token", param).then(resp => {
                                console.log(resp);
                                resolve(messaging);
                            });
                        } else {
                            reject('No Instance ID token available. Request permission to generate one.');
                            console.log('No Instance ID token available. Request permission to generate one.');

                        }
                    }).catch(function (err) {
                        reject(err);
                        console.log('An error occurred while retrieving token. ', err);
                    });
                    messaging.onTokenRefresh(function () {
                        messaging.getToken().then(function (refreshedToken) {
                            console.log('Token refreshed.');
                            console.log("refresh Token: " + refreshedToken);
                            let param = new URLSearchParams();
                            param.append("token", refreshedToken);
                            param.append("branch_id", state.user.branch.id);
                            axios.post(state.mainAppURL + "restaurants/update_branch_fcm_token", param).then(resp => {
                                console.log(resp);
                            });
                            // ...
                        }).catch(function (err) {
                            reject(err);
                            console.log('Unable to retrieve refreshed token ', err);
                        });
                    });
                    // messaging.onMessage(async function (payload) {
                    //     let requestType= payload.data.request_type;
                    //     console.log('Message received. ', payload);
                    //     await dispatch('showNotifications', payload.data)
                    //     switch(requestType){
                    //         case "new_order":
                    //             await dispatch('updateOrderStatusToAssigned', payload.data.order_id)
                    //             break;
                    //     }
                    //     await commit('update_branch_new_order', true)
                        // if(parseInt(payload.data.status_id)===7){
                        //     toast= toastr.error("<div> <b>" + payload.data.orderId +"</b> order id is unassigend<br> Status: <b>" + payload.data.status +"</b> <br> Branch: <b>" + payload.data.branch +"</b> <br><br><button type='button' id='toastr' class='btn btn-info btn-xs'>Acknowledge</button><button type='button' id='viewOrders' style='margin-left:5px;' class='btn btn-info btn-xs'>View Orders</button></div>")
                        // }else if(parseInt(payload.data.status_id)===22){
                        //     toast= toastr.warning("<div> Order Id <b>" + payload.data.orderId +"</b> has been prepared but customer has not picked it up. <br>Status: <b>" + payload.data.status +"</b> <br> Branch: <b>" + payload.data.branch +"</b> <br><br><button type='button' id='toastr' class='btn btn-info btn-xs'>Acknowledge</button><button type='button' id='viewOrders' style='margin-left:5px;' class='btn btn-info btn-xs'>View Orders</button></div>")
                        // }else if(parseInt(payload.data.status_id)===2){
                        //     toast= toastr.info("<div> Order Id <b>" + payload.data.orderId +"</b> has been prepared but but not marked Ready for Delivery. <br>Status: <b>" + payload.data.status +"</b> <br> Branch: <b>" + payload.data.branch +"</b> <br><br><button type='button' id='toastr' class='btn btn-info btn-xs'>Acknowledge</button><button type='button' id='viewOrders' style='margin-left:5px;' class='btn btn-info btn-xs'>View Orders</button></div>")
                        // }
                    // });
                }).catch(function (err) {
                    reject('Unable to get permission to notify.' + err);
                    console.log('Unable to get permission to notify.', err);
                });
            });

        },
        keepRingingNotificationBell({state}){
            state.notificationRing.play();
            state.notificationRing.loop = true;
            state.notificationRing.playbackRate = 2;
        },
        stopNotificationBell({state}){
            if(state.notificationRing !== null && !state.notificationRing.paused) {
                state.notificationRing.pause();
            }
        },
        showNotifications({state, commit, dispatch}, data) {
            // eslint-disable-next-line no-undef
            let requestType= data.request_type;
            let toastObject = "";
            toastr.options = {
                "closeButton": true,
                "debug": false,
                "progressBar": true,
                "preventDuplicates": false,
                "positionClass": "toast-top-right",
                "showDuration": "5",
                "hideDuration": "0",
                "timeOut": "0",
                "extendedTimeOut": "0",
                "showEasing": "swing",
                "hideEasing": "linear",
                "showMethod": "fadeIn",
                "hideMethod": "fadeOut"
            };
            // eslint-disable-next-line no-undef
            switch(requestType){
                case "new_order":
                    toastObject = toastr.info("<div class='viewOrders' id='" + state.newOrderId +"'><b>New Order Recieved on Branch " + state.user.branch.areasByAreaId.name + "</b><br> ORDER-ID: "+  state.newOrderId +"</div>")
                    break;
                case "cancelled_order":
                    toastObject = toastr.error("<div class='viewOrders' id='" + state.newOrderId +"'><b>Order of branch "+ state.user.branch.areasByAreaId.name +" Has Been Cancelled.</b><br> ORDER-ID: " + state.newOrderId +"</div>")
                    break
            }
            commit('toast', toastObject);
            commit('update_branch_new_order', true);
            dispatch("keepRingingNotificationBell");

            // eslint-disable-next-line no-undef
            $('.viewOrders').click(async function (event) {
                let order_id= event.currentTarget.id;
                commit('fetch_order_detail', true);
                commit('new_order_id', order_id);
                window.location.href = '/#/branch_orders';
            });
            commit('bell_on', false)
            commit('bell_on', requestType === 'cancelled_order')
        },
        async updateOrderStatusToAssigned({state}, orderId) {
            try {
                await axios.get(state.mainAppURL + 'orders/assign_to_branch' , { params:
                {
                    orderId : orderId
                }
            });
            } catch (e) {
                console.log(e)
            }
        },

        removeBranchFCM({state},) {
            if(state.user.branch) {
                let param = new URLSearchParams();
                param.append("token", null);
                param.append("branch_id", state.user.branch.id);
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.accessToken;
                axios.post(state.mainAppURL + "restaurants/update_branch_fcm_token", param);
            }
        },
        refreshBillingAndSubscriptionDatatable({state, commit}, refreshFlag){
            commit('refresh_datatable', refreshFlag);
        },
        validateUserAndCreateWebsocketConnection({state, dispatch}) {
            if (state.websocket === null && state.user.userRolesById[0].role === "ROLE_BRANCH" && state.user.branch.isPortalEnabled) {
                dispatch('createWebSocket');
            }
        },
        createWebSocket({state, commit, dispatch}){
            let branch_id= state.user.branch.id;
            let mainURL= state.mainAppURL.replace("http", "ws");
            let tempWebsocket= new WebSocket( mainURL + 'restaurants/real_time_order_details/'+ branch_id);
            commit('websocket', tempWebsocket);
            state.websocket.onopen = function (){
                console.log("Opening the websocket connection of branch id:" + branch_id);
            };
            state.websocket.onclose = function () {
                commit('websocket', null);
                console.log("Websocket connection close successfully!");
            };
            state.websocket.onmessage = async function (payload) {
                let message = JSON.parse(payload.data);
                let order_id = message.order_id;
                if(message.request_type === "connection_close"){
                    dispatch("closeWebsocketConnection");
                }
                else {
                    if (message.request_type === "new_order") {
                        await dispatch('updateOrderStatusToAssigned', order_id);
                    }
                    await commit('new_order_id', order_id);
                    await dispatch('showNotifications', message);
                }
            };
            state.websocket.onerror= function (error){
                console.log("Error in web socket connection of branch id: "+ branch_id + "\n" + error);
            };
        },
        closeWebsocketConnection({state}){
            console.log("Closing websocket connection of branch id: " + state.user.branch.id);
            state.websocket.close();
        },
        updateCollapseValue({state, commit}, val){
            commit('updateCollapseValue', val);
        },
    }
})
